import {
  all, put, select, takeLatest,
} from 'redux-saga/effects';
import { compareBladeObjects, copyBlades } from '../../utils/objectUtils';
import { getVisibility } from './visibilitySelector';
import { updateDisplayAndFocus } from './visibilityLogic';
import { visibilityActions } from './visibilityActions';
import { VisibilityState } from './visibilityReducer';

export function* bladeCompleteSaga(action: ReturnType<typeof visibilityActions.bladeComplete>) {
  const Visibility: VisibilityState = yield select(getVisibility);

  const bladeName = action.payload;
  if (bladeName) {
    // Copy visibility object so it can be modified
    const visibility = copyBlades(Visibility);

    // Update the visibility object
    updateDisplayAndFocus(bladeName, visibility);

    // Compare original visibility object with modified object and put the
    // updated blades into the updatedBlades array.
    const updatedBlades: VisibilityState = compareBladeObjects(Visibility, visibility);

    if (Object.keys(updatedBlades).length === 0) {
      // This code is to address an issue where the bladeCompleteSaga is dispatched
      // but there doesn't seem to be any change in the visibility list. It occurs
      // when a user completes a blade (Blade A) and the next blade (Blade B) is
      // displayed, given focus, and the browser scrolls to it. If the user scrolls
      // back to Blade A and hits "complete" again, there is no change in the visibility
      // list (because Blade B already has focus) and the browser does not scroll as the
      // reducer did not return a changed state. To force scrolling to work, we ensure
      // that the blade with focus is updated so that "componentDidUpdate" executes in App.tsx
      // and the scroll occurs.
      Object.keys(visibility).forEach((name: string) => {
        if (visibility[name].hasFocus) {
          updatedBlades[name] = visibility[name];
        }
      });
    }
    yield put(visibilityActions.bladesUpdate(updatedBlades));
  }
}

function* watchForCompletedBlade() {
  yield takeLatest(visibilityActions.bladeComplete, bladeCompleteSaga);
}

export default function* visbilitySaga() {
  yield all([watchForCompletedBlade()]);
}
